<router-outlet></router-outlet>

<app-footer class="footer bg-white d-flex flex-lg-column" id="kt_footer"></app-footer>
